export const PEPE = {
  MINI: {
    '--standard-mini-pure-black-color': '#000000',
    '--standard-mini-pure-white-color': '#ffffff',
    '--standard-mini-primary-color': '#000',
    '--standard-mini-secondary-color': '#000012',
    '--standard-mini-primary-text-color': '#fff',
  },
}
